module.exports = __webpack_public_path__ + "static/media/theresistance-cards.30cda71e.jpg";